import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import FillingCard from '../components/Card';
import { mountCardAttributes } from '../utils';
import { changeAddWebClientNotificationAttrs } from '../../../store/AddWebClientNotifications';

import { StoreState } from '../../../store/types';
import { ILoadingContainerCardInfo } from '../types';

export default (cardInfo: ILoadingContainerCardInfo) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state: StoreState = useSelector((reduxState: StoreState) => reduxState);

  const {
    notification,
    notificationAttrs,
  } = state.addWebClientNotificationsState;
  const { title, running, attributes, notLoadingWidth } = cardInfo;
  const { peerIP, organization } = attributes || {};

  const changeNotification = (params: Record<string, any>) => {
    dispatch(changeAddWebClientNotificationAttrs(params));
  };

  const newCardInfo = {
    running,
    notLoadingWidth,
    notificationAttrs,
    changeNotification,
    titleFontSize: '22px',
    loadingInfo: notification,
    canShow: peerIP && organization,
    attributes: mountCardAttributes(attributes || {}, t),
    loadingStarted: Object.keys(notification).length > 0,
  };

  return <FillingCard cardInfo={{ ...newCardInfo, title }} />;
};
